export enum ChatMessageRole {
    USER = 'USER',
    AGENT = 'AGENT',
}
